<template>
  <div style="height: 100vh;background-color: #ffffff;">
    <vue-element-loading is-full-screen :active="loading && !regised && !checkOtp" spinner="bar-fade-scale" color="#152d51" />
    <div class="navbar nav-main w-100" style="background-color:#23409A;color:white">
      <h3 class="w-100 text-center my-3">เปลี่ยนแปลงที่อยู่</h3>
    </div>
    <div class="w-100 session-with-nav " style="height: calc(100vh - 67px);overflow: auto;">
      <div class="mb-2 flex-all-center">
        <div>
          <v-img class="my-0 radius-circle" style="width:170px;height:auto" src="@/assets/logo_long.png"></v-img>
        </div>
      </div>
      <div class="px-5">
        <div class="text-blue">กรุณากรอกที่อยู่ใหม่</div>
        <FormUpdateAddress @submit="submit" :option="showOp" :loading="loading" />
      </div>
    </div>
    <ShowSuccessDialog v-if="showDone" v-model="showDone">ระบบได้ทำการแก้ไขที่อยู่ ให้ท่านเรียบร้อยแล้ว</ShowSuccessDialog>
  </div>
</template>

<script>
import api from "@/api";
import config from "@/config";
import VueElementLoading from "vue-element-loading";
import FormUpdateAddress from "@/components/formUpdateAddress.vue";
import ShowSuccessDialog from "@/components/SuccessDialog.vue";
export default {
  components: { VueElementLoading, FormUpdateAddress, ShowSuccessDialog },
  data() {
    return {
      pop: false,
      userData: null,
      loading: true,
      loadingMain: true,
      showCountdowntimer: true,
      otp: "",
      address: {
        addressNo: "",
        floor: "",
      },
      showDone: false,
      addressData: [],
      updateData: {},
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
    profile() {
      return this.$store.state.profile;
    },
    userId() {
      return this.$store.state.profile.userId;
    },
    checkOtp() {
      return this.$store.state.checkOtp;
    },
    selectContact() {
      return this.$store.state.selectContact;
    },
    showOp() {
      if (this.$store.state.addressType && this.$store.state.addressType != "ที่อยู่จัดส่งเอกสาร") {
        return true;
      } else {
        return false;
      }
    },
    regised() {
      if (this.userId && this.userData && this.userData.cardnumber && this.userData.status == "ผูกบัญชีแล้ว") {
        return true;
      } else {
        return false;
      }
    },
    mainAddress() {
      return this.$store.state.selectAddress;
      // if (this.addressData && this.addressData.length) {
      //   let data = this.addressData.filter((x) => {
      //     return x.isMaillingAddress === "Yes";
      //   });
      //   return data && data.length ? data[0] : [];
      // } else {
      //   return null;
      // }
    },
  },
  watch: {
    userId: {
      immediate: true,
      handler(userId) {
        if (userId) {
          this.setup();
        }
      },
    },
  },
  mounted() {
    //   this.setup()
  },
  methods: {
    async askmore() {
      await this.$store.dispatch("sendMessage", "สอบถามเพิ่มเติมเรื่อง OTP");
      this.$liff.closeWindow();
    },
    async setup() {
      await this.fetchUserData(this.userId);
      // await this.fetchAddress(this.userId);
      this.loading = false;
      this.loadingMain = false;
    },
    async submit(data) {
      if (this.userId && this.mainAddress && this.mainAddress.addressCode && this.mainAddress.isMaillingAddress && this.mainAddress.addressType && this.selectContact) {
        this.updateData = {
          lineUserId: this.userId,
          AgreementNo: this.selectContact,
          addressCode: this.mainAddress.addressCode,
          ...data,
          addressType: this.mainAddress.addressType,
        };
        if (data.isMaillingAddress == null) {
          this.updateData.isMaillingAddress = this.mainAddress.isMaillingAddress;
        }
        this.loading = true;
        let isDone = await this.fetchUpdateAddress({ address: { ...this.updateData }, pageid: config.pageid });
        this.loading = false;
        if (isDone) {
          let question_ans = await this.$swal.fire({
            title: "ต้องการเปลี่ยนแปลงที่อยู่อื่นหรือไม่",
            type: "question",
            showCancelButton: true,
            confirmButtonText: "ต้องการ",
            cancelButtonText: "ไม่ต้องการ",
            customClass: {
              header: "header-class",
              title: "fs-19 text-blue",
              content: "fs-16",
              confirmButton: "main-btn col-10 m-0 fs-14 bg-blue",
              cancelButton: "main-btn col-10 m-0 fs-14 mysilver mt-3",
              actions: "p-0 w-100 d-flex flex-row justify-content-center",
            },
          });
          if (question_ans && question_ans.isConfirmed) {
            this.$router.push("/selectAddress");
          } else {
            this.showDone = true;
          }
        } else {
          this.$swal.fire({
            type: "error",
            text: "อัพเดทข้อมูลไม่สำเร็จ",
          });
        }
      } else {
        console.log("Data Not found");
      }
      // must add lineUserId isMaillingAddress addressType
    },
    async fetchUserData(userId) {
      if (userId) {
        let res = await api.getUser(userId);
        if (res.responsecode == 200 && res.data.id) {
          this.userData = res.data;
        } else {
          console.log("error fetch user data");
        }
      }
    },
    // async fetchAddress(userId) {
    //   if (userId) {
    //     const body = {
    //       LineUserID: userId,
    //     };
    //     let res = await api.getaddress(body);
    //     console.log(res);
    //     if (res && res.length) {
    //       this.addressData = res;
    //     } else {
    //       console.log("error fetch user data");
    //     }
    //   }
    // },
    async fetchUpdateAddress(data) {
      if (data) {
        let res = await api.regisedUpdateAddress(data);
        if (res && res.length) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
};
</script>

<style></style>
